import apiClient from '../api/client';
import { ApiResponse } from '../../types/api.types';

export interface PublicJob {
  id: number;
  title: string;
  location: string;
  employment_type: 'Full-time' | 'Part-time' | 'Contract' | 'Internship';
  department: string;
  short_description: string;
  full_description: string;
  responsibilities?: string;
  requirements?: string;
  salary?: string;
  created_at: string;
}

export interface JobFilters {
  locations: string[];
  types: string[];
  departments: string[];
}

export interface GetPublicJobsParams {
  location?: string;
  type?: string;
  department?: string;
  search?: string;
}

export interface JobApplicationData {
  job_id: number;
  full_name: string;
  email: string;
  phone_number: string;
  resume: File;
  cover_letter?: string;
}

class JobService {
  private async makePublicCall<T>(url: string, config: any = {}): Promise<T> {
    const response = await apiClient.get<ApiResponse<T>>(url, config);
    return response.data.data;
  }

  async getAllJobs(params: GetPublicJobsParams = {}): Promise<PublicJob[]> {
    return this.makePublicCall<PublicJob[]>('/api/jobs', { params });
  }

  async getJobById(id: number | string): Promise<PublicJob> {
    return this.makePublicCall<PublicJob>(`/api/jobs/${id}`);
  }

  async getJobFilters(): Promise<JobFilters> {
    return this.makePublicCall<JobFilters>('/api/jobs/filters');
  }

  async applyForJob(data: JobApplicationData): Promise<any> {
    const formData = new FormData();
    formData.append('job_id', data.job_id.toString());
    formData.append('full_name', data.full_name);
    formData.append('email', data.email);
    formData.append('phone_number', data.phone_number);
    formData.append('resume', data.resume);
    if (data.cover_letter) {
      formData.append('cover_letter', data.cover_letter);
    }

    const response = await apiClient.post('/api/jobs/apply', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }
}

export default new JobService();
